import styled from '@emotion/styled';
import {
  AddCircleOutlineSmallIcon,
  CheckCircleOutlineSmallIcon,
  NotIncludedOutlineSmallIcon,
  TextCaption,
  token,
} from '@angeplus/prever-component-lib';

export const PlanVersionCaptions = () => {
  return (
    <PlanVersionCaptionsContainer>
      <PlanVersionCaptionsItem>
        <CheckCircleOutlineSmallIcon
          color={token.colors.feedbackSuccessPrimary}
        />
        <TextCaption>Incluso no valor</TextCaption>
      </PlanVersionCaptionsItem>
      <PlanVersionCaptionsItem>
        <AddCircleOutlineSmallIcon color={token.colors.accentPrimary} />
        <TextCaption>Disponível por valor adicional</TextCaption>
      </PlanVersionCaptionsItem>
      <PlanVersionCaptionsItem>
        <NotIncludedOutlineSmallIcon color={token.colors.neutralLight} />
        <TextCaption>Indisponível</TextCaption>
      </PlanVersionCaptionsItem>
    </PlanVersionCaptionsContainer>
  );
};

const PlanVersionCaptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: ${token.spacing.spacingXxSmall};
  border-radius: ${token.borderRadius.borderRadiusMedium};
  border: 1px solid ${token.colors.neutralXLight};
  gap: ${token.spacing.spacingXxxSmall};
`;

const PlanVersionCaptionsItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${token.spacing.spacingXxxSmall};
`;
